import type { ReactNode } from 'react';

export const symbol_select_check_box: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-120q-24.75 0-42.37-17.63Q120-155.25 120-180v-600q0-24.75 17.63-42.38Q155.25-840 180-840h571q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H180v600h600v-337q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v337q0 24.75-17.62 42.37Q804.75-120 780-120H180Zm281-252 361-361q9-9 21-9t21 9q9 9 9 21.2 0 12.19-9 20.8L482-309q-9 9-21 9t-21-9L260-489q-9-9-9-21t9-21q9-9 21-9t21 9l159 159Z"
		/>
	</svg>
);
